import{FilterType as o}from"../cosmograph/types.js";const t={accessor:o=>o.value,customExtent:void 0,data:void 0,filterFunction:void 0,filterType:o.Nodes,onSelection:void 0,highlightCrossfiltered:!0};export{t as defaultCosmographHistogramConfig};
//# sourceMappingURL=config.js.map
